/**
 * Helpers compartidos para mostrar estado de suscripción TOMi.digital (msubscriptions status).
 */

export const T8_MSUBSCRIPTIONS_QA_STORAGE_KEY = 't8_msubscriptions_env';

/** Solo en npm start. El build de producción siempre usa PROD. */
export function t8MsubscriptionsIsDevSwitch() {
  return process.env.NODE_ENV === 'development';
}

export function t8MsubscriptionsReadQaFlag() {
  if (!t8MsubscriptionsIsDevSwitch()) return false;
  try {
    return localStorage.getItem(T8_MSUBSCRIPTIONS_QA_STORAGE_KEY) === 'qa';
  } catch {
    return false;
  }
}

/** Normaliza ISO o Y-m-d a Y-m-d en zona America/Bogota cuando hay hora. */
export function normalizeDateYmd(value) {
  if (!value) return null;
  const raw = String(value).trim();
  if (!raw) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
  if (/^\d{4}-\d{2}-\d{2}T/.test(raw)) {
    try {
      const dt = new Date(raw);
      if (Number.isNaN(dt.getTime())) return raw.slice(0, 10);
      const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Bogota',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).formatToParts(dt);
      const y = parts.find((p) => p.type === 'year')?.value;
      const m = parts.find((p) => p.type === 'month')?.value;
      const d = parts.find((p) => p.type === 'day')?.value;
      if (y && m && d) return `${y}-${m}-${d}`;
    } catch {
      return raw.slice(0, 10);
    }
  }
  return raw.slice(0, 10);
}

export function tomiDisplayName(status) {
  const user = status?.user;
  if (!user) return '';
  const name = `${user.first_name || ''} ${user.last_name || ''}`.trim();
  return name || '';
}

/** Fecha de fin de la suscripción interna (la que sincronizamos con T8). */
export function tomiInternalEndsAt(status) {
  return status?.internal?.ends_at || null;
}

/**
 * Fecha de vencimiento del acceso TOMi del usuario (administrable o no).
 * Preferencia: effective → internal → stripe → pin activo → pin más reciente.
 * Devuelve ISO string, o '__perpetual__' si el pin activo es perpetuo.
 */
export function tomiSubscriptionEndsAt(status) {
  if (!status || typeof status !== 'object') return null;

  if (status.effective?.ends_at) return status.effective.ends_at;
  if (status.internal?.ends_at) return status.internal.ends_at;

  const stripe = status.stripe;
  if (stripe && stripe.present) {
    const stripeEnd =
      stripe.ends_at
      || stripe.current_period_end
      || stripe.cancel_at
      || stripe.period_end
      || stripe.trial_end
      || null;
    if (stripeEnd) return stripeEnd;
  }

  const pins = Array.isArray(status.pins) ? status.pins : [];
  const activePins = pins.filter((p) => p && p.active);
  if (activePins.some((p) => p.perpetual)) {
    return '__perpetual__';
  }
  const activeWithEnd = activePins.find((p) => p.computed_ends_at);
  if (activeWithEnd?.computed_ends_at) return activeWithEnd.computed_ends_at;

  let best = null;
  let bestTs = -Infinity;
  pins.forEach((p) => {
    if (!p?.computed_ends_at || p.perpetual) return;
    const ts = Date.parse(p.computed_ends_at);
    if (!Number.isNaN(ts) && ts > bestTs) {
      bestTs = ts;
      best = p.computed_ends_at;
    }
  });
  return best;
}

export function formatTomiEndsDisplay(rawEnds) {
  if (rawEnds === '__perpetual__') return 'Perpetua';
  return normalizeDateYmd(rawEnds) || '—';
}

export function tomiHasActiveInternal(status) {
  return Boolean(status?.internal?.present && status?.internal?.active);
}
